import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VincularPage from '@common/vincular/vincular.page';
import * as commonActions from '@common/common.action';
import WebapiCommon from '@util/webapi.common';
import { acessoPermitido } from '../../../acessos.seguranca';
import { Label } from 'reactstrap';
import * as actions from '../../../pages/laudo/etapas/material/material.action';
import CommonFunctions from '@util/functions.common';
import IntlMessage from "../../../helpers/intlMessage";

class VincularContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detalhes: props.detalhes,
      exames: props.exames,
      showModal: false,
      justificativa: null,
      mesmoMaterial: false,
      vincularTexto: 'vincular',
    };
  }

  componentDidMount() {
    if (
      this.props.detalhes.laudoAnterior &&
      this.props.detalhes.laudoAnterior !== '0'
    ) {
      this.setState({
        vincularTexto: 'desvincular',
      });
    } else {
      this.setState({
        vincularTexto: 'vincular',
      });
    }
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.getExamesFinalizados(this.state.detalhes.prontuario).then(
      (exames) => {
        let examesfiltrados = [...exames];
        examesfiltrados = examesfiltrados.filter(
          (el) => el.laudo !== this.props.detalhes.laudo
        );

        this.props.commonActions.preencherExamesConcluidos(examesfiltrados);
        this.setState({
          exames: examesfiltrados,
        });
        this.props.commonActions.showFadeCarregando(false);
      }
    );
  }
  render() {
    const { showModal, justificativa, mesmoMaterial } = this.state;
    return (
      <VincularPage
        usuario={this.props.usuario}
        exames={this.state.exames}
        exameselecionado={this.props.exameselecionado}
        tiposelecionado={this.props.tiposelecionado}
        onClick={this.onClick.bind(this)}
        vincularExame={this.vincularExame.bind(this)}
        desvincularExame={this.desvincularExame.bind(this)}
        retornarUltimaEtapa={this.retornarUltimaEtapa.bind(this)}
        laudoAnterior={this.state.detalhes.laudoAnterior}
        acessoPermitido={acessoPermitido}
        altura={this.props.altura}
        checkCard={this.check.bind(this)}
        showModal={showModal}
        toggleModal={this.toggleModal.bind(this)}
        updateState={this.updateState.bind(this)}
        justificativa={justificativa}
        mesmoMaterial={mesmoMaterial}
        updateMesmoMaterial={this.updateMesmoMaterial.bind(this)}
        atualizarVincularTexto={this.atualizarVincularTexto.bind(this)}
        vincularTexto={this.state.vincularTexto}
        frascosGravados={this.props.frascosGravados}
        recebimentoFinalizado={this.props.recebimentoFinalizado}
        exameFinalizado={this.props.exameFinalizado}
      />
    );
  }

  atualizarVincularTexto(e) {
    let texto = 'vincular';

    if (e) {
      console.log(e);
    }

    this.setState({ vincularTexto: texto });
  }

  onClick(item) {
    this.props.commonActions.exameSelecionado(item);
  }

  check(item) {
    return (
      (this.props.exameselecionado !== undefined &&
        this.props.exameselecionado.id === item.id) ||
      item.laudo === parseInt(this.state.detalhes.laudoAnterior, 10)
    );
  }

  vincularExame() {
    const tipoVinculo = this.state.mesmoMaterial;
    const laudoExameSelecionado = this.props.exameselecionado.laudo;
    const laudoExame = this.state.detalhes.laudo;
    this.props.commonActions.showFadeCarregando(true);

    WebapiCommon.vincularLaudoAnterior(
      laudoExame,
      laudoExameSelecionado,
      this.state.justificativa,
      tipoVinculo
    ).then((result) => {
      this.setState({ justificativa: '' });
      this.toggleModal(laudoExameSelecionado);
      if (result.success) {
        WebapiCommon.obterStatusEtapasLaudo(laudoExame).then((etapas) => {
          this.props.commonActions.atualizarStatusDasEtapasDoLaudo(
            etapas,
            laudoExame
          );

          if (result.data.vinculoUtilizaMesmoNumeroExame) {
            this.props.commonActions.atualizarPropriedadeNoItemDaLista(
              laudoExame,
              'nrExame',
              result.data.numeroExame
            );
          }

          this.atualizarLaudoAnteriorDetalhes(
            laudoExameSelecionado,
            result.data.numeroExameAnterior
          );

          this.props.commonActions.atualizarPropriedadeNoItemDaLista(
            laudoExame,
            'laudoAnterior',
            laudoExameSelecionado
          );

          this.props.commonActions.atualizarPropriedadeNoItemDaLista(
            laudoExame,
            'numeroExameAnterior',
            result.data.numeroExameAnterior
          );

          this.props.commonActions.showFadeCarregando(false);
          this.props.commonActions.showAlerta(
            'sucesso',
            'Vinculo realizado com sucesso!',
            2000
          );

          this.setState({ vincularTexto: 'desvincular' });
          if (result.data.vinculoUtilizaMesmoNumeroExame) {
            CommonFunctions.fecharExameEtapaRecebimento(this.props);
          }
        });
      } else {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'erro',
          result.data[0].message,
          2000
        );
      }
    });
  }

  desvincularExame() {
    const laudo = this.state.detalhes.laudo;
    WebapiCommon.desvincularLaudoAnterior(
      laudo,
      this.state.justificativa,
      this.state.detalhes.nrPedido
    ).then((result) => {
      this.setState({ justificativa: '' });
      this.toggleModal();
      if (result.success) {
        this.props.commonActions.showFadeCarregando(false);
        this.atualizarLaudoAnteriorDetalhes('0');
        this.props.commonActions.atualizarPropriedadeNoItemDaLista(
          laudo,
          'laudoAnterior',
          0
        );

        this.props.commonActions.atualizarPropriedadeNoItemDaLista(
          laudo,
          'numeroExameAnterior',
          ''
        );

        this.props.commonActions.showAlerta(
          'sucesso',
          'Exame desvinculado',
          2000
        );

        this.setState({ vincularTexto: 'vincular' });

        if (result.data.vinculoUtilizaMesmoNumeroExame) {
          WebapiCommon.obterStatusEtapasLaudo(laudo).then((etapas) => {
            this.props.commonActions.atualizarStatusDasEtapasDoLaudo(
              etapas,
              laudo
            );
            this.props.commonActions.atualizarPropriedadeNoItemDaLista(
              laudo,
              'nrExame',
              ''
            );
            CommonFunctions.fecharExameEtapaRecebimento(this.props);
          });
        }
      } else {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'erro',
          result.data[0].message,
          2000
        );
      }
    });
  }

  retornarUltimaEtapa(etapas) {
    let conclusao = etapas.find((etp) => {
      return etp.etapa === 'CONCLUSAO';
    });

    let macroscopia = etapas.find((etp) => {
      return etp.etapa === 'MACRO';
    });

    let macroFinalizada = macroscopia.status === 'realizado';

    let status_etapas = '';
    etapas.forEach((etapa) => {
      if (etapa.status !== 'naoaplicavel') {
        let executante =
          etapa.medicoEtapa !== ''
            ? ` executada por ${etapa.medicoEtapa}`
            : ' executada';

        let data;
        if (etapa.dataEtapa !== '') {
          data = ` em ${etapa.dataEtapa}`;
        } else {
          executante = ' pendente';
          data = '';
        }
        status_etapas += `Etapa ${etapa.etapa}${executante}${data}\n`;
      }
    });

    return (
      <div style={{ float: 'left', display: 'contents' }}>
        <Label style={{ marginTop: '12px' }}>
          {conclusao.status !== 'realizado' && (
            <div style={{ display: 'flex' }}>
              <div className='exame-aberto'><IntlMessage id = "dashboards.reports.inProgress"/></div>
              {!macroFinalizada && (
                <div className='exame-aberto'><IntlMessage id = "dashboards.examDetail.pendingMacro"/></div>
              )}
              <i
                data-toggle='tooltip'
                title={status_etapas}
                className='fas fa-question info-etapas'
              ></i>
            </div>
          )}
          {conclusao.status === 'realizado' && (
            <div style={{ display: 'flex' }}>
              <div className='exame-finalizado'><IntlMessage id = "dashboards.reports.finished"/></div>
              {!macroFinalizada && (
                <div className='exame-aberto'><IntlMessage id = "dashboards.examDetail.pendingMacro"/></div>
              )}
              <i
                data-toggle='tooltip'
                title={status_etapas}
                className='fas fa-question info-etapas'
              ></i>
            </div>
          )}
        </Label>
      </div>
    );
  }
  atualizarLaudoAnteriorDetalhes(laudoAnterior, numeroExameAnterior) {
    let detalhes = this.state.detalhes;
    detalhes.laudoAnterior = laudoAnterior;
    detalhes.numeroExameAnterior = numeroExameAnterior;

    this.props.commonActions.atualizarDetalhes(detalhes);

    this.setState({
      detalhes,
    });
  }

  fecharDetalhes() {
    this.props.funcFechar();
  }

  toggleModal(exame) {
    this.props.commonActions.exameSelecionado(exame);
    this.setState((state) => ({
      showModal: !state.showModal,
      justificativa: null,
    }));
  }

  updateState(el) {
    this.setState({
      [el.currentTarget.name]: el.currentTarget.value,
    });
  }

  updateMesmoMaterial(name, value) {
    this.setState({
      [name]: value,
    });
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    exames: state.recebimentoMaterial.exames,
    exameselecionado: state.commonReducer.exameVincular,
    detalhes: state.commonReducer.detalhes,
    frascosNovos: state.commonReducer.frascosNovos,
    frascosGravados: state.commonReducer.frascosGravados,
    listagem: state.commonReducer.listagem,
    recebimentoFinalizado: state.recebimentoMaterial.recebimentoFinalizado,
    exameFinalizado: state.commonReducer.exameFinalizado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VincularContainer);



// WEBPACK FOOTER //
// ./src/app/common/vincular/vincular.container.js